import {FC} from "react";
import {Stack} from "@fluentui/react";
import {DiagnosisReport as DiagnosisReportModel} from "../../api/models";
import styles from "./Answer.module.css";

interface IProps {
    report: DiagnosisReportModel;
}

interface ISection {
    label: string;
    value?: string;
}

export const DiagnosisReport: FC<IProps> = ({report}) => {
    const sections: ISection[] = [
        {label: "What happened", value: report.what_happened},
        {label: "Why it happened", value: report.why_it_happened},
        {label: "Why it matters", value: report.why_it_matters},
        {label: "Follow up with", value: report.follow_up_with}
    ];

    const hasContent =
        report.title ||
        report.time_period ||
        sections.some((section) => section.value);

    if (!hasContent) {
        return null;
    }

    return (
        <div className={styles.diagnosisReport}>
            {report.title && (
                <div className={styles.diagnosisReportTitle}>{report.title}</div>
            )}
            {report.time_period && (
                <div className={styles.diagnosisReportPeriod}>
                    {report.time_period}
                </div>
            )}
            <Stack tokens={{childrenGap: 12}} styles={{root: {marginTop: 12}}}>
                {sections
                    .filter((section) => section.value)
                    .map((section) => (
                        <div key={section.label}>
                            <div className={styles.diagnosisReportLabel}>
                                {section.label}
                            </div>
                            <div className={styles.diagnosisReportValue}>
                                {section.value}
                            </div>
                        </div>
                    ))}
            </Stack>
        </div>
    );
};
